var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _g2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharacter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 351,
    viewBox: "0 0 352 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351 346.68H1",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1089 217.744C34.1089 217.744 26.5308 215.994 24.7808 207.838C23.0308 199.682 28.6636 203.174 23.6167 190.354C18.562 177.534 19.7339 174.619 21.4761 170.924C23.2261 167.237 24.1949 168.401 25.7495 173.252C27.3042 178.112 32.937 185.69 35.0777 199.87C37.2183 214.049 34.1089 217.744 34.1089 217.744Z",
    fill: "#92E3A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0677 203.948C49.0677 203.948 44.013 202.198 43.8255 192.682C43.6302 183.159 47.5208 185.104 48.0989 173.253C48.677 161.401 49.4583 153.05 51.5989 152.854C53.7395 152.659 59.3723 158.682 61.3098 171.893C63.2551 185.104 58.7864 193.846 54.8958 197.737C51.013 201.62 49.0677 203.956 49.0677 203.956V203.948Z",
    fill: "#92E3A9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3903 229.206C31.3903 229.206 30.2262 222.214 27.8902 218.909C25.5621 215.605 20.5074 212.691 17.2028 206.284C13.8981 199.87 10.2106 196.761 10.4059 205.894C10.6012 215.026 14.6793 219.691 19.734 222.8C24.7887 225.909 31.3903 229.214 31.3903 229.214V229.206Z",
    fill: "#92E3A9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2565 241.253C29.2565 241.253 24.5924 232.316 17.7955 225.706C10.9986 219.097 5.55333 215.8 7.49865 219.097C9.44396 222.401 11.7721 222.206 15.0768 228.034C18.3815 233.862 17.4049 238.136 22.069 241.441C26.733 244.745 29.2565 241.245 29.2565 241.245V241.253Z",
    fill: "#92E3A9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6709 252.714C28.4756 252.128 28.2802 247.854 21.6787 244.362C15.0693 240.862 8.85837 242.221 9.63181 243.971C10.4052 245.721 14.4912 248.635 18.5693 250.385C22.6474 252.135 28.6709 252.714 28.6709 252.714Z",
    fill: "#92E3A9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6861 229.596C48.6861 229.596 45.772 225.901 47.3267 218.136C48.8814 210.362 52.3814 212.307 56.2642 208.229C60.147 204.151 59.3736 203.565 63.2564 199.292C67.1392 195.018 70.6392 192.682 72.1939 194.432C73.7486 196.182 71.4205 201.62 69.0845 204.729C66.7564 207.839 63.0611 209.393 61.3111 213.276C59.5611 217.159 60.3424 223.378 55.8736 226.292C51.4049 229.206 48.6861 229.596 48.6861 229.596Z",
    fill: "#92E3A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3975 231.737C58.3975 231.737 65.3897 223.768 70.4443 217.94C75.499 212.112 77.4365 207.643 77.6318 211.526C77.8271 215.409 79.3818 218.518 75.3037 223.573C71.2256 228.628 58.3975 231.729 58.3975 231.729V231.737Z",
    fill: "#92E3A9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7014 244.557C54.7014 244.557 54.5061 241.448 65.5842 234.26C76.6623 227.073 81.3186 225.714 80.1545 228.628C78.9905 231.542 74.1311 234.456 68.8889 239.706C63.6467 244.948 54.7092 244.565 54.7092 244.565L54.7014 244.557Z",
    fill: "#92E3A9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7881 204.432C48.8818 204.385 48.9678 204.315 48.999 204.214C49.0146 204.167 49.4443 202.784 50.085 200.628C50.2256 200.253 50.3584 199.878 50.5068 199.51C50.5225 199.471 50.5068 199.432 50.4678 199.417C50.46 199.417 50.4521 199.417 50.4443 199.417C51.9678 194.19 54.2959 185.792 55.2959 179.924C56.7021 171.643 55.4287 165.299 54.585 161.096C54.4912 160.628 54.4053 160.19 54.3271 159.776C54.2881 159.565 54.085 159.424 53.8662 159.464C53.6553 159.503 53.5146 159.706 53.5537 159.924C53.6318 160.339 53.7178 160.784 53.8193 161.253C54.6553 165.401 55.9131 171.667 54.5303 179.799C52.999 188.799 48.3115 203.839 48.2646 203.987C48.21 204.167 48.2959 204.354 48.4521 204.44C47.2334 207.94 46.249 211.518 45.3818 215.12C44.1475 220.471 43.249 225.893 42.624 231.354L42.2334 235.456C42.1709 236.143 42.1006 236.823 42.0459 237.51L41.9365 239.565C41.874 240.94 41.7959 242.307 41.7568 243.682L41.7959 247.807L41.8428 249.87C41.874 250.557 41.9209 251.245 41.9678 251.924C42.0693 253.292 42.1553 254.667 42.2803 256.034C42.5459 258.768 42.9521 261.487 43.374 264.19C43.374 264.221 43.4131 264.253 43.4443 264.253C43.4834 264.253 43.5146 264.221 43.5146 264.182C43.5146 262.807 43.4521 261.44 43.4209 260.073C43.3818 258.706 43.2646 257.346 43.2803 255.979C43.2803 254.612 43.249 253.253 43.2334 251.885L43.1943 249.839L43.2334 247.792L43.249 243.706L43.3584 239.62L43.3975 237.573C43.4209 236.893 43.4756 236.214 43.5146 235.534L43.7646 231.456C44.2412 226.026 44.9912 220.612 46.0771 215.268C46.8193 211.628 47.6787 207.995 48.7881 204.44V204.432Z",
    fill: "#858585"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.826 228.37C59.8651 230.245 57.2166 232.612 54.9041 235.276C53.7713 236.628 52.7088 238.042 51.8104 239.581L51.1776 240.784L50.6776 242.034C50.4979 242.448 50.3729 242.87 50.2401 243.3C50.1151 243.722 49.9666 244.151 49.8572 244.581C48.9666 248.011 48.3807 251.511 48.2166 255.026C48.076 258.542 48.1385 262.058 48.6073 265.55C48.6073 265.581 48.6385 265.612 48.6776 265.612C48.7166 265.612 48.7557 265.589 48.7557 265.542L49.6619 255.128C50.0213 251.683 50.2401 248.222 50.9823 244.855C51.076 244.433 51.1932 244.026 51.3026 243.612C51.4119 243.198 51.5135 242.784 51.6697 242.386L52.0916 241.183L52.6385 240.042C53.4432 238.534 54.4198 237.097 55.4744 235.737C57.5916 233.011 60.076 230.519 62.9119 228.503C62.9119 228.503 62.951 228.433 62.9276 228.401C62.9041 228.37 62.8651 228.355 62.826 228.378V228.37Z",
    fill: "#858585"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1953 241.776C55.5781 242.815 54.5 244.456 53.5938 246.104C52.7266 247.792 52.0469 249.573 51.5781 251.409C51.4375 251.862 51.3281 252.323 51.2266 252.784L50.8984 254.167C50.7344 255.096 50.6016 256.034 50.5469 256.979C50.5313 257.924 50.5078 258.87 50.5703 259.807C50.6484 260.752 50.7578 261.69 50.9375 262.62C50.9375 262.643 50.9688 262.674 50.9922 262.674C51.0313 262.682 51.0703 262.659 51.0781 262.62C51.3047 261.69 51.4531 260.768 51.5781 259.854C51.7266 258.94 51.8672 258.026 51.9766 257.112C52.1094 256.206 52.2344 255.299 52.3047 254.385C52.4297 253.479 52.5 252.557 52.6953 251.667C53.0156 249.862 53.5312 248.096 54.2422 246.409C54.9453 244.737 55.8594 243.073 57.2656 241.893H57.2734C57.2734 241.893 57.3047 241.823 57.2891 241.792C57.2656 241.76 57.2266 241.752 57.1875 241.768L57.1953 241.776Z",
    fill: "#858585"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5851 252.206C40.1945 247.581 39.4367 243.003 38.7101 238.425C37.9836 233.847 37.1867 229.284 36.3508 224.73C35.8664 222.206 35.3742 219.683 34.8586 217.159C34.9367 217.073 34.9758 216.956 34.9523 216.831C34.9289 216.691 32.3195 202.761 29.6242 192.956C26.9367 183.159 25.1711 177.081 25.1555 177.019C25.093 176.808 24.882 176.691 24.6711 176.753C24.4601 176.816 24.343 177.027 24.4055 177.237C24.4211 177.3 26.1867 183.37 28.8742 193.167C31.5617 202.948 34.1633 216.847 34.1867 216.98C34.218 217.136 34.3273 217.245 34.4758 217.284C34.882 219.808 35.2648 222.331 35.6398 224.855C36.3351 229.425 36.9836 234.003 37.5695 238.589C38.132 243.175 38.5773 247.777 39.1476 252.355L40.843 266.12C40.843 266.12 40.8742 266.183 40.9133 266.183C40.9523 266.183 40.9836 266.152 40.9914 266.112C41.0461 264.956 41.0461 263.792 41.0773 262.628C41.0851 261.464 41.0305 260.308 41.007 259.144C40.968 256.823 40.7648 254.511 40.593 252.198L40.5851 252.206Z",
    fill: "#858585"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8116 252.143C37.5616 250.315 37.2257 248.487 36.8819 246.674L36.2335 243.971C36.0225 243.073 35.8194 242.167 35.5538 241.284C34.6319 237.698 33.4522 234.182 32.0225 230.768L31.4678 229.495L31.171 228.893C31.171 228.831 31.1553 228.776 31.1241 228.721C31.1241 228.713 31.0225 228.542 30.8585 228.26C30.4678 227.409 29.9913 226.612 29.546 225.807C28.6319 224.323 27.6788 222.838 26.421 221.604C25.6553 220.581 24.8272 219.518 23.9366 218.463C22.835 217.159 21.8194 216.042 20.835 214.948C18.0772 211.893 15.8975 209.487 14.4757 205.94C14.3975 205.737 14.1632 205.643 13.9678 205.721C13.7647 205.799 13.671 206.026 13.7491 206.229C15.2178 209.909 17.4366 212.362 20.2491 215.471C21.2257 216.557 22.2413 217.674 23.335 218.963C27.5382 223.924 30.421 229.049 30.4522 229.104C30.4991 229.19 30.585 229.245 30.671 229.268L30.8819 229.745L31.3663 231.026C32.6475 234.448 33.671 237.971 34.4444 241.542C34.8663 243.323 35.1475 245.135 35.4913 246.924L35.921 249.635C36.0772 250.534 36.2725 251.432 36.3975 252.338C36.6866 254.143 37.0147 255.948 37.335 257.76C37.6163 259.573 37.9444 261.385 38.3272 263.198C38.3272 263.229 38.3663 263.26 38.3975 263.26C38.4366 263.26 38.4678 263.229 38.4678 263.19C38.4757 261.346 38.4366 259.495 38.335 257.651C38.2257 255.807 38.0069 253.971 37.8194 252.135L37.8116 252.143Z",
    fill: "#858585"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9839 252.377C33.1246 249.948 32.1324 247.573 31.0543 245.245C29.9449 242.932 28.7496 240.659 27.3746 238.495C27.3511 238.463 27.3121 238.456 27.2808 238.471C27.2496 238.495 27.2339 238.534 27.2574 238.573C28.4605 240.823 29.4761 243.167 30.398 245.534C31.3355 247.901 32.1793 250.299 32.8902 252.737C33.6168 255.174 34.1324 257.659 34.7808 260.104C35.4605 262.549 36.0152 265.018 36.7652 267.495C36.773 267.526 36.8043 267.549 36.8355 267.549C36.8746 267.549 36.9058 267.518 36.9058 267.479C36.9449 264.893 36.6871 262.315 36.1871 259.784C35.7339 257.237 34.8355 254.807 33.9839 252.377Z",
    fill: "#858585"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8268 260.455C33.3893 258.94 32.6393 257.518 31.7878 256.19C30.9518 254.846 29.9831 253.58 28.8268 252.51C28.7018 252.401 28.5768 252.299 28.4518 252.197C28.4518 252.197 28.4362 252.182 28.4284 252.174H28.4128C27.944 251.776 27.4675 251.401 26.944 251.088C26.5221 250.822 26.0846 250.596 25.6237 250.401C23.2878 248.947 19.9128 246.924 17.1862 245.565C16.9909 245.471 16.7565 245.549 16.6628 245.737C16.569 245.932 16.6471 246.166 16.8346 246.26C21.4206 248.557 27.9284 252.783 27.9987 252.822C28.0612 252.862 28.1237 252.877 28.1862 252.877C28.2253 252.924 28.2721 252.963 28.3034 253.002C29.3034 254.119 30.1081 255.408 30.7721 256.744C31.4753 258.072 31.8346 259.541 32.444 260.908C32.7096 261.611 32.9831 262.315 33.2956 263.018C33.5612 263.736 33.8503 264.447 34.2253 265.151C34.2253 265.151 34.2643 265.19 34.2878 265.197C34.3268 265.197 34.3659 265.166 34.3659 265.127C34.3971 264.338 34.3503 263.549 34.28 262.76C34.1628 261.987 33.9987 261.213 33.819 260.447L33.8268 260.455Z",
    fill: "#858585"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1166 197.784C67.9291 197.675 67.6947 197.729 67.5775 197.917C65.8119 200.862 62.3978 204.8 59.1088 208.604C57.0228 211.01 55.0541 213.284 53.6166 215.175C49.9057 220.05 48.3588 229.143 48.2963 229.534C48.2807 229.643 48.3041 229.745 48.3666 229.823C48.2572 230.284 48.14 230.745 48.0385 231.206C47.2807 234.721 46.6869 238.284 46.3197 241.87C45.9603 245.448 45.5541 249.026 45.5072 252.62C45.4525 256.214 45.5072 259.807 45.89 263.401C45.89 263.432 45.9213 263.464 45.9525 263.464C45.9916 263.464 46.0307 263.44 46.0307 263.401C46.4447 259.823 46.7025 256.253 46.9447 252.682C47.1947 249.112 47.2338 245.534 47.4682 241.964C47.6869 238.409 48.1322 234.862 48.7416 231.339C48.8353 230.807 48.9369 230.276 49.0307 229.745C49.0463 229.714 49.0541 229.69 49.0619 229.651C49.0775 229.557 50.64 220.362 54.2338 215.643C55.6557 213.768 57.6166 211.51 59.6947 209.112C63.015 205.284 66.4447 201.323 68.2494 198.315C68.3588 198.128 68.3041 197.893 68.1166 197.776V197.784Z",
    fill: "#858585"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6479 291.667C65.2104 279.877 52.1088 272.018 52.1088 272.018H32.0307C32.0307 272.018 18.9291 279.877 18.4916 291.667C18.0541 303.456 33.3354 346.682 33.3354 346.682H50.7885C50.7885 346.682 66.0698 303.456 65.6323 291.667H65.6479Z",
    fill: "#858585"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6943 260.424H29.0771L32.0381 272.018H51.7412L54.6943 260.424Z",
    fill: "#858585"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.229 1H12.9482V125.18H106.229V1Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.189 5.05518H15.9941V121.133H103.189V5.05518Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9873 90.2974C25.7607 85.2349 46.8936 71.7427 52.667 47.4224C57.2295 28.2114 63.8389 14.1802 73.9326 5.05518",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.418 121.133C52.3945 101.586 44.832 63.6645 65.9414 38.4849C79.2617 22.5942 92.5898 13.438 103.199 8.17236",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7842 5.05518C25.8389 10.1099 30.2295 18.8599 28.8389 32.2583C27.3545 46.6099 20.8467 54.7192 15.9873 58.8833",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6441 121.132C85.8238 110.75 75.1285 112.312 67.8316 102.656C58.6285 90.4761 67.5582 72.3355 88.6754 63.9292C95.2769 61.3042 99.9254 57.5151 103.191 53.5464",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9873 113.703C22.3857 103.937 30.4092 94.7185 35.3311 100.226C39.4326 104.812 40.417 113.226 40.2451 121.14",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0732 5.05518C38.292 16.3599 39.6592 37.3364 46.7061 28.4692C51.6201 22.2974 55.5107 12.7895 58.1201 5.05518",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.19 21.4839C91.729 31.3667 71.8071 49.7417 85.1587 47.148C92.2681 45.7651 98.3853 41.3901 103.19 36.5698",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.334 34.1567H176.756V196.008H294.334V34.1567Z",
    fill: "#263238",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.741 41.3745H182.358V188.781H288.741V41.3745Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.767 64.1943L220.532 90.4287",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.461 50.4917L249.391 61.5698",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.984 72.6475L213.242 88.3896",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.196 176.132L220.532 180.796",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.461 140.859L227.812 173.507",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.984 163.016L213.242 178.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.444 121.117C239.444 119.156 237.858 117.57 235.897 117.57C233.937 117.57 232.351 119.156 232.351 121.117C232.351 123.078 233.937 124.664 235.897 124.664C237.858 124.664 239.444 123.078 239.444 121.117Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.741 120.61H182.358V127.133H288.741V120.61Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.796 24.4688H173.991V38.3047H297.796V24.4688Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.796 191.165H173.991V205H297.796V191.165Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.375 5.10156H129.727V9.25H341.375V5.10156Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.586 1.64893H140.844C138.906 1.64893 137.336 3.21943 137.336 5.15674V216.704C137.336 218.641 138.906 220.211 140.844 220.211H145.586C147.523 220.211 149.094 218.641 149.094 216.704V5.15674C149.094 3.21943 147.523 1.64893 145.586 1.64893Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.656 1.64893H151.914C149.977 1.64893 148.406 3.21943 148.406 5.15674V216.704C148.406 218.641 149.977 220.211 151.914 220.211H156.656C158.594 220.211 160.164 218.641 160.164 216.704V5.15674C160.164 3.21943 158.594 1.64893 156.656 1.64893Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.719 1.64893H162.977C161.039 1.64893 159.469 3.21943 159.469 5.15674V216.704C159.469 218.641 161.039 220.211 162.977 220.211H167.719C169.656 220.211 171.227 218.641 171.227 216.704V5.15674C171.227 3.21943 169.656 1.64893 167.719 1.64893Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.788 1.64893H174.046C172.109 1.64893 170.538 3.21943 170.538 5.15674V216.704C170.538 218.641 172.109 220.211 174.046 220.211H178.788C180.725 220.211 182.296 218.641 182.296 216.704V5.15674C182.296 3.21943 180.725 1.64893 178.788 1.64893Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.75 1.64893H293.008C291.07 1.64893 289.5 3.21943 289.5 5.15674V216.704C289.5 218.641 291.07 220.211 293.008 220.211H297.75C299.687 220.211 301.258 218.641 301.258 216.704V5.15674C301.258 3.21943 299.687 1.64893 297.75 1.64893Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.82 1.64893H304.078C302.141 1.64893 300.57 3.21943 300.57 5.15674V216.704C300.57 218.641 302.141 220.211 304.078 220.211H308.82C310.758 220.211 312.328 218.641 312.328 216.704V5.15674C312.328 3.21943 310.758 1.64893 308.82 1.64893Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.882 1.64893H315.14C313.202 1.64893 311.632 3.21943 311.632 5.15674V216.704C311.632 218.641 313.202 220.211 315.14 220.211H319.882C321.819 220.211 323.39 218.641 323.39 216.704V5.15674C323.39 3.21943 321.819 1.64893 319.882 1.64893Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.954 1.64893H326.212C324.275 1.64893 322.704 3.21943 322.704 5.15674V216.704C322.704 218.641 324.275 220.211 326.212 220.211H330.954C332.891 220.211 334.462 218.641 334.462 216.704V5.15674C334.462 3.21943 332.891 1.64893 330.954 1.64893Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.921 309.343C191.921 309.343 164.382 317.163 160.476 317.843C156.569 318.523 155.038 317.499 151.124 319.03C147.218 320.562 139.397 322.257 139.397 322.257C139.397 322.257 121.382 325.484 112.03 325.148C102.679 324.812 99.2802 323.616 99.2802 323.616L96.2177 322.765C96.2177 322.765 94.6864 325.827 94.5146 328.374C94.3427 330.921 95.3661 343.671 95.3661 343.671C95.3661 343.671 99.4443 342.484 109.476 344.523C119.507 346.562 134.804 349.28 146.194 347.413C157.585 345.546 158.436 344.015 162.515 343.507C166.593 342.999 180.53 347.077 183.765 346.905C186.991 346.734 263.319 346.905 263.319 346.905C263.319 346.905 271.14 343.679 277.772 338.749C284.405 333.82 296.304 330.593 300.038 321.749C303.78 312.913 294.429 303.562 289.499 302.882C284.569 302.202 260.093 311.038 259.069 311.21C258.046 311.382 254.96 308.515 254.96 308.515L191.921 309.343Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M208.037 315.351L212.725 320.757",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204.257 315.351C204.257 315.351 212.726 323.28 214.53 327.062",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M243.366 315.53C243.366 315.53 237.601 320.038 235.077 323.999",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M238.14 316.25C238.14 316.25 233.632 322.195 232.194 325.437",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M186.686 241.547C186.686 241.547 179.576 246.969 174.342 251.087C169.107 255.204 163.49 259.688 157.506 262.313C151.521 264.93 134.123 265.118 121.779 269.797C109.436 274.477 94.6543 277.282 94.6543 277.282L96.1543 288.321C96.1543 288.321 147.029 285.891 157.506 283.274C167.982 280.657 168.17 278.782 173.217 281.219C178.264 283.657 194.545 306.657 194.545 306.657L190.053 307.594L190.428 310.399C190.428 310.399 199.404 314.704 213.811 313.766C228.217 312.829 239.061 312.087 242.24 311.899C245.42 311.712 254.959 308.532 254.959 308.532C254.959 308.532 252.904 297.305 248.412 279.54C243.92 261.766 244.107 251.11 244.107 251.11L268.795 260.837C268.795 260.837 269.545 270.001 267.857 283.094C266.178 296.188 264.303 301.61 264.303 301.61L277.021 305.727C277.021 305.727 283.756 273.18 285.998 263.829C288.24 254.477 284.498 250.172 281.881 247.93C279.264 245.688 247.279 226.235 239.607 223.985C231.936 221.743 222.209 221.555 217.912 222.86C213.607 224.172 202.764 228.469 202.764 228.469L186.678 241.563L186.686 241.547Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M202.46 309.062C204.608 309.547 207.351 309.898 210.78 309.898C221.694 309.898 223.28 309.305 223.28 309.305",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M195.904 306.329C195.904 306.329 196.951 307.274 199.459 308.188",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M231.466 310.087C232.7 309.743 233.88 309.353 234.981 308.907",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M204.037 312.282C204.037 312.282 217.123 313.071 228.076 310.883",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M166.614 277.095C163.942 274.595 159.231 270.494 155.45 268.861",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M168.724 279.15C168.724 279.15 168.396 278.814 167.833 278.267",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M163.114 269.048C163.114 269.048 168.349 272.79 169.661 274.47",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M241.864 250.345C241.864 250.345 236.63 249.407 234.192 245.478",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M200.591 260.939C206.966 262.923 213.583 264.642 218.106 264.939",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M181.263 254.088C181.263 254.088 188.771 257.096 197.481 259.948",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M217.896 279.501C219.833 280.322 221.614 280.97 223.161 281.392",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M183.13 259.884C183.13 259.884 201.591 271.985 215.091 278.259",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M182.294 267.533C183.708 268.556 184.778 269.314 184.997 269.423",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M173.404 261.01C173.404 261.01 176.803 263.533 179.928 265.814",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M213.731 239.447C213.63 240.22 213.474 240.994 213.247 241.736",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M212.686 229.58C212.686 229.58 213.896 233.212 213.873 237.291",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M164.998 206.562C164.998 206.562 165.444 215.641 165.748 217.625C166.053 219.602 163.6 226.57 168.045 233.508C170.561 237.445 170.022 243.406 172.92 244.164C175.811 244.922 183.115 241.883 183.115 241.883C183.115 241.883 185.248 245.844 186.311 248.43C187.373 251.016 193.615 257.719 200.319 253.453C207.014 249.188 209.451 235.492 208.694 232.75C207.936 230.008 206.561 228.336 205.803 227.727C205.045 227.117 203.217 225.289 202.756 224.07C202.303 222.852 201.694 219.961 201.998 217.375C202.303 214.789 203.365 204.586 201.084 200.938C198.803 197.281 194.233 194.242 185.709 194.242C177.186 194.242 169.881 197.437 169.881 197.437C169.881 197.437 171.553 194.547 170.186 195.156C168.819 195.766 167.6 197.437 167.6 197.437C167.6 197.437 167.295 193.172 165.772 195.609C164.248 198.047 164.404 200.938 164.404 200.938C164.404 200.938 163.342 199.719 163.186 201.547C163.037 203.375 165.014 206.57 165.014 206.57L164.998 206.562Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M201.99 217.368C202.295 214.782 203.358 204.579 201.076 200.93C198.795 197.274 194.225 194.235 185.701 194.235C177.178 194.235 169.873 197.43 169.873 197.43C169.873 197.43 171.545 194.54 170.178 195.149C168.811 195.758 167.592 197.43 167.592 197.43C167.592 197.43 167.287 193.165 165.764 195.602C164.24 198.04 164.397 200.93 164.397 200.93C164.397 200.93 163.334 199.711 163.178 201.54C163.029 203.368 165.006 206.563 165.006 206.563C165.006 206.563 167.139 207.782 168.358 207.321C169.576 206.868 171.483 205.641 172.623 205.344C176.67 204.29 183.733 203.977 182.217 206.102C180.701 208.227 178.256 209.297 180.084 210.516C181.912 211.735 187.389 212.797 187.694 214.477C187.998 216.149 187.842 219.5 189.522 218.586C191.194 217.672 191.959 214.626 194.545 215.391C197.131 216.149 199.264 219.5 198.35 222.086C197.436 224.672 198.654 225.282 200.936 223.454C201.412 223.071 201.842 222.594 202.24 222.071C201.983 220.704 201.819 218.977 202.006 217.368H201.99Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M191.498 217.985C191.498 217.985 194.225 214.024 196.201 214.024C198.178 214.024 200.615 216.61 198.334 222.095C196.053 227.571 193.006 228.181 192.248 224.532",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M191.498 217.985C191.498 217.985 194.225 214.024 196.201 214.024C198.178 214.024 200.615 216.61 198.334 222.095C196.053 227.571 193.006 228.181 192.248 224.532",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M168.615 217.024L169.623 219.555C169.623 219.555 168.615 227.641 169.287 228.993C169.959 230.344 174.342 229.5 174.342 229.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M170.811 233.539C170.811 233.539 175.865 235.226 180.248 230.171",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M172.998 215.007C172.998 215.007 177.889 212.984 180.584 214.671",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M168.115 215.844L166.428 215.008",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M177.717 218.961C177.717 219.844 177.264 220.563 176.709 220.563C176.154 220.563 175.701 219.844 175.701 218.961C175.701 218.078 176.154 217.359 176.709 217.359C177.264 217.359 177.717 218.078 177.717 218.961Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M168.913 219.539C168.913 220.367 168.507 221.039 168.007 221.039C167.507 221.039 167.101 220.367 167.101 219.539C167.101 218.711 167.507 218.039 168.007 218.039C168.507 218.039 168.913 218.711 168.913 219.539Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M183.115 241.875C183.115 241.875 189.537 240.508 190.607 239.258C191.678 238.008 191.146 240.867 190.428 245.156C189.709 249.445 188.279 250.703 188.279 250.703C188.279 250.703 187.029 249.633 185.951 246.945C184.881 244.266 183.107 241.875 183.107 241.875H183.115Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9514 291.563C67.9514 291.563 63.4046 298.524 63.5452 306.906C63.6858 315.289 67.803 338.438 69.6546 343.125C71.4983 347.813 74.9124 352.07 80.0217 349.375C85.1311 346.68 88.8264 346.391 91.3811 346.25C93.9358 346.109 97.2014 345.539 97.4905 339.859C97.7718 334.18 96.0686 328.352 96.0686 328.352C96.0686 328.352 98.7639 323.094 98.0608 320.539C97.3499 317.984 90.2483 316.422 88.9671 314.859C87.6858 313.297 84.2796 302.219 83.1468 299.234C82.0139 296.25 81.8655 293.836 82.1546 291.563C82.4358 289.289 83.9983 283.75 79.1702 284.742C74.3421 285.734 71.6389 288.719 67.9514 291.563Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7012 314.172C85.7012 314.172 87.1074 313.547 88.2012 313.547",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4502 310.891C84.4502 310.891 85.8564 309.953 86.6377 309.953",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9824 306.984L85.2324 306.515",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M83.428 333.461C80.5843 326.218 77.3186 312.297 77.3186 300.789C77.3186 289.281 79.3889 286.976 80.4436 284.64C80.0764 284.617 79.6624 284.64 79.1702 284.734C74.3421 285.726 71.6389 288.711 67.9514 291.554C67.9514 291.554 63.4046 298.515 63.5452 306.898C63.6858 315.281 67.803 338.429 69.6546 343.117C71.4983 347.804 74.9124 352.062 80.0217 349.367C82.0374 348.304 83.8342 347.617 85.4202 347.164C85.5217 344.062 85.3655 338.398 83.428 333.461Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4592 335.875C76.0452 328.343 74.7639 317.265 74.3421 304.765C74.0061 295.007 77.3967 287.585 78.9046 284.804C74.2483 285.851 71.5764 288.773 67.9514 291.554C67.9514 291.554 63.4046 298.515 63.5452 306.898C63.6858 315.281 67.803 338.429 69.6546 343.117C71.4983 347.804 74.9124 352.062 80.0217 349.367C80.0452 349.351 80.0686 349.343 80.0921 349.328C80.4046 346.843 80.3108 341.656 78.4592 335.867V335.875Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M264.311 301.593C264.311 301.593 253.233 301.937 252.499 302.429C251.765 302.921 242.89 307.359 241.655 308.101C240.421 308.843 238.202 312.289 238.819 313.031C239.436 313.773 240.788 313.523 241.655 313.281C242.515 313.031 244.733 312.664 244.733 312.664C244.733 312.664 243.007 314.14 243.749 314.265C244.491 314.39 247.819 313.406 248.679 312.906C249.538 312.414 258.171 310.32 259.155 310.32C260.14 310.32 267.046 311.304 271.233 309.828C275.421 308.351 277.038 305.71 277.038 305.71L264.319 301.593H264.311Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M244.734 312.655C244.734 312.655 254.609 307.718 255.391 307.397C256.18 307.085 258.219 306.452 258.219 306.452",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M238.82 313.031C238.82 313.031 246.117 308.82 246.906 308.507C247.695 308.195 254.766 304.734 254.766 304.734",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M239.985 310.015C239.985 310.015 243.853 307.733 244.376 307.499C244.899 307.265 252.579 303.577 252.579 303.577",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M219.227 330.774C219.227 330.774 213.555 327.446 209.735 326.587C205.915 325.727 201.844 327.821 199.016 327.821C196.188 327.821 189.282 324.86 183.985 324.743C178.688 324.618 172.524 331.032 173.266 335.837C174.008 340.641 175.977 344.337 181.524 345.821C187.071 347.298 210.235 346.931 210.235 346.931L220.836 346.313C220.836 346.313 219.727 339.657 219.727 336.946C219.727 334.235 219.235 330.782 219.235 330.782L219.227 330.774Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M201.407 333.532C201.407 333.532 198.439 336.657 200.001 342.274",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M205 334C205 334 202.032 337.125 203.594 342.743",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M208.585 334.47C208.585 334.47 205.616 337.595 207.179 343.212",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M212.181 334.938C212.181 334.938 209.212 338.063 210.775 343.681",
    stroke: "#263238",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M181.516 345.813C181.602 345.837 181.704 345.86 181.797 345.876C180.352 345.016 178.524 343.712 177.821 342.235C176.586 339.649 176.219 338.782 176.961 337.306C177.704 335.829 178.321 334.962 178.321 332.743C178.321 330.524 178.446 328.923 178.446 328.923C178.446 328.923 181.524 325.845 183.868 325.72C185.711 325.626 192.438 326.751 196.485 327.407C193.094 326.595 188.071 324.829 183.993 324.727C178.696 324.602 172.532 331.016 173.274 335.821C174.016 340.626 175.985 344.321 181.532 345.806L181.516 345.813Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M284.663 306.376C284.663 306.376 267.905 311.056 258.663 315.376C249.421 319.688 233.272 329.181 233.272 329.181L219.226 330.782C219.226 330.782 219.226 341.501 219.351 342.86C219.476 344.22 220.827 346.313 220.827 346.313C220.827 346.313 245.718 344.095 256.319 342.368C266.921 340.642 287.749 332.509 292.796 329.181",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M284.663 306.376C284.663 306.376 267.905 311.056 258.663 315.376C249.421 319.688 233.272 329.181 233.272 329.181L219.226 330.782C219.226 330.782 219.226 341.501 219.351 342.86C219.476 344.22 220.827 346.313 220.827 346.313C220.827 346.313 245.718 344.095 256.319 342.368C266.921 340.642 287.749 332.509 292.796 329.181",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M221.555 331.423C221.555 331.423 233.18 330.024 250.258 319.938C259.164 314.681 265.25 313.251 269.859 312.095",
    stroke: "#949494",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M209.732 326.586C205.912 325.727 201.842 327.82 199.014 327.82C201.6 328.188 205.912 328.313 208.748 327.453C209.404 327.25 210.107 327.063 210.803 326.883C210.436 326.773 210.076 326.672 209.74 326.594L209.732 326.586Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9292 279.062C96.9292 279.062 95.3667 277.359 92.9526 276.929C90.5385 276.499 81.7339 274.374 80.0307 274.796C78.3276 275.226 71.5073 281.898 70.5151 283.601C69.5229 285.304 67.2495 292.976 67.5307 293.968C67.812 294.96 67.1011 295.39 69.8042 293.687C72.4995 291.984 73.7807 289.71 75.9136 287.578C78.0464 285.445 79.1792 284.734 79.1792 284.734C79.1792 284.734 82.3042 284.023 82.8745 284.023C83.4448 284.023 85.8667 282.859 84.5854 285.843C83.3042 288.828 79.8901 292.687 80.6011 294.539C81.312 296.382 81.4526 295.39 83.5854 293.687C85.7182 291.984 87.562 291.132 87.562 291.132C87.562 291.132 91.3979 290.14 92.3901 289.57C93.3823 288.999 96.7964 289.851 97.6479 284.742C98.4995 279.624 96.937 279.062 96.937 279.062H96.9292Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7963 293.694C69.7963 293.694 69.226 292.124 70.5463 290.147C71.8667 288.163 77.312 281.562 78.1401 280.905C78.9682 280.241 80.4526 279.585 80.4526 279.585",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5234 293.977C67.5234 293.977 69.2188 288.82 70.5391 286.508C71.8594 284.195 75.1641 280.898 75.3281 280.234C75.4922 279.57 77.4766 278.25 77.4766 278.25",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/Character.45cdd77a5b8c7cdb5f6c12b8556246b5.svg";
export { ForwardRef as ReactComponent };